export const UserStatus = Object.freeze({
  Active: "1",
  Requested: "0",
  Inactive: "-1"
});

export const AssistantAssignment =  Object.freeze({
  Assigned: 2,
  BrokerRequested: 1,
  AssistantRequested: 0
});


// WEBPACK FOOTER //
// ./src/enums/user_management.js